import React, { useState, useEffect } from "react";
import styles from "./style.module.css";
import Layout from "../../Components/Layout";
import { useForm } from "react-hook-form";
import { CiSquarePlus } from "react-icons/ci";
import { searchfilter } from "../../Services/APIrequests";
import { useNavigate } from "react-router-dom";
import { SuccessSwal, warningSwal } from "../../Util/Toast";
import { useLocation } from "react-router-dom";
import {
    segments,
    revenueRanges,
    industry,
    creditRatings,
    dataStatuses,
    chargeMonths,
} from "./data";
import {
    getDistinctClassifications,
    getDistinctcorporatestatus,
    getDistinctlistingStatus,
    getDistinctCompanyIndustry,
    getDistinctCompanySegment,
} from "../../Services/APIrequests";
import { RotatingLines } from "react-loader-spinner";

function Mysearch() {
    const [searchResults, setSearchResults] = useState([]);

    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        onSubmit();
    }, [location.state?.requestBody]);

    const onSubmit = async () => {
        setLoading(true);
        try {
            const response = await searchfilter(
                location.state?.requestBody || {}
            );
            setLoading(false);
            if (response?.data?.data?.length) {
                setSearchResults(response.data.data);
                SuccessSwal("Companies found!", "The search was successful.");
            } else {
                setSearchResults([]);

                warningSwal(
                    "No companies found",
                    "Please try a different search term."
                );
            }

            setErrorMessage("");
        } catch (error) {
            const errorMessage =
                error.isAxiosError && error.response
                    ? error.response.data.message ||
                      "An unexpected error occurred"
                    : "An unexpected error occurred";
            setLoading(false);
            setErrorMessage(errorMessage);
            warningSwal("Error", errorMessage);
            console.error("Error during search:", error);
        }
    };

    const handleRowClick = (cin) => {
        navigate(`/kohere/Companydetails/${cin}`);
    };

    return (
        <div>
            <>
                <Layout Active={"My Search"}>
                    <div className={styles.Mysearchtable}>
                        <table className={styles.commantable}>
                            <thead className={styles.table_header}>
                                <tr className={styles.tableHeaderRow}>
                                    <th className={styles.tableHeader}>Name</th>
                                    <th className={styles.tableHeader}>
                                        Authorized Capital
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Company Category
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Address
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Status
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Principal Business Activity
                                    </th>
                                    <th className={styles.tableHeader}>
                                        State
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Registrar
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td
                                            colSpan="8"
                                            style={{
                                                textAlign: "center",
                                                padding: "20px",
                                            }}>
                                            <RotatingLines
                                                height="50"
                                                width="50"
                                                strokeColor="#4fa94d"
                                                ariaLabel="loading"
                                                visible={true}
                                            />
                                        </td>
                                    </tr>
                                ) : Array.isArray(searchResults) &&
                                  searchResults.length > 0 ? (
                                    searchResults.map((result, index) => (
                                        <tr
                                            key={index}
                                            onClick={() =>
                                                handleRowClick(result.CIN)
                                            }>
                                            <td>{result.CompanyName}</td>
                                            <td>
                                                {Number(
                                                    result.Authorized_Capital
                                                ).toLocaleString("en-IN")}
                                            </td>
                                            <td>{result.Company_Category}</td>
                                            <td>
                                                {result.RegisteredOfficeAddress}
                                            </td>
                                            <td>{result.Company_Status}</td>
                                            <td>
                                                {
                                                    result.Principal_BusinessActivity
                                                }
                                            </td>
                                            <td>{result.Registered_State}</td>
                                            <td>
                                                {result.Registrar_Of_Companies}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="8"
                                            style={{ textAlign: "center" }}>
                                            No results found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Layout>
            </>
        </div>
    );
}

export default Mysearch;
